import { render, staticRenderFns } from "./ProformaInvoiceProductDialog.vue?vue&type=template&id=4a6ac1f0&scoped=true"
import script from "./ProformaInvoiceProductDialog.vue?vue&type=script&lang=js"
export * from "./ProformaInvoiceProductDialog.vue?vue&type=script&lang=js"
import style0 from "./ProformaInvoiceProductDialog.vue?vue&type=style&index=0&id=4a6ac1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ac1f0",
  null
  
)

export default component.exports